import Sortable from "sortablejs/Sortable"

$ ->

  if $('#js-bulk_clips').length > 0
    # 並び替えページ
    if $('#js-bulk_clips-edit').length > 0
      press = document.querySelector('.js-sortable-press')
      spot = document.querySelector('.js-sortable-spot')
      sortable = new Sortable.create(press, {
        group: press
        handle: '.js-sortable-handle'
        animation: 100
      })
      sortable = new Sortable.create(spot, {
        group: spot
        handle: '.js-sortable-handle'
        animation: 100
      })
      $('.js-sortable-handle').addClass('c-sortable__handle').css('display','flex')
